import styled from "styled-components";
import React, {useState} from "react";
import {Draggable} from "react-beautiful-dnd";
import {IS_HEAD} from "../../permissions/roleTypes";
import {useDispatch, useSelector} from "react-redux";
import userImage from '../../images/account.svg'
import {getDateInFrench} from "../../utils/dateUtils";
import AddActionInKanbanButton from "../buttons/AddActionInKanbanButton";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import ContributionModal from "../modal/ContributionModal";
import YesNoModal from "../modal/YesNoModal";
import {deleteContribution} from "./contributionsActions";
import {loadProject} from "../project/one-project/projectAction";
import {DisplayForHead} from "../../permissions/DisplayAccordingToRole";
import {getImage} from "../../utils/utils";
import ActionModal from "../modal/action/ActionModal";

const Task = ({task, index}) => {

    const {roles, id: currentUserId} = useSelector(state => state.currentUser)
    const {pilot, copilot, id: projectId, axisSponsor} = useSelector(state => state.project)
    const [isOpenEditModal, setIsOpenEditModal] = useState(false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [isOpenModal, setOpenModal] = useState(false)
    const dispatch = useDispatch()
    const isAuthorized = pilot.id === currentUserId || copilot?.id === currentUserId
    const isDragDisabled = (!IS_HEAD(roles) && !isAuthorized) || task.action !== null


    const handleDeleteContribution = async (id) => {
        await dispatch(deleteContribution(id))
        await dispatch(loadProject(projectId))
        setIsOpenDeleteModal(false)
    }


    const displayModal = () => {
        if (isOpenModal) {
            return (
                <ActionModal
                    setOpenModal={setOpenModal}
                    selectedActionId={0}
                    inActionPage={false}
                    task={task}
                />
            )
        }
        if (isOpenEditModal) {
            return <ContributionModal setIsOpen={setIsOpenEditModal} task={task}/>
        }

        if (isOpenDeleteModal) {
            return <YesNoModal
                name={"cette contribution"}
                handleClickYesAction={handleDeleteContribution}
                setOpenModal={setIsOpenDeleteModal}
                id={task.id}
            />
        }
    }


    return (
        <Draggable
            draggableId={task.id}
            index={index}
            isDragDisabled={isDragDisabled}
        >
            {(provided, snapshot) => (
                <Container
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    isDragging={snapshot.isDragging}
                    {...provided.dragHandleProps}
                    isDragDisabled={isDragDisabled}
                    hasAction={task.action !== null}
                >
                    <PilotContainer
                        isDragging={snapshot.isDragging}
                        hasAction={task.action !== null}
                    >
                        <img src={getImage(task.author.photo, userImage)}
                             alt={task.author.firstName + " " + task.author.lastName}/>
                        <p>{task.author.firstName} {task.author.lastName}</p>

                    </PilotContainer>
                    <Content>
                        <p>{task.content}</p>
                    </Content>
                    <LastSection>
                        <Date>
                            <p> Le {getDateInFrench(task.creationDate)}</p>
                        </Date>
                        <ButtonsContainer>
                            {(task.action === null && task.state === "toCreate") &&
                                <DisplayForHead
                                    hasException={currentUserId === pilot.id || currentUserId === task.author.id || (copilot ? copilot.id === currentUserId : false) || (axisSponsor ? axisSponsor.id === currentUserId : false)}
                                    component={<AddActionInKanbanButton setOpenModal={setOpenModal}/>}/>
                            }
                            <DisplayForHead
                                hasException={currentUserId === pilot.id || currentUserId === task.author.id || (copilot ? copilot.id === currentUserId : false) || (axisSponsor ? axisSponsor.id === currentUserId : false)}
                                component={
                                    <EditButton
                                        setUpdate={setIsOpenEditModal}
                                        data={isOpenEditModal}/>
                                }
                            />
                            <DisplayForHead
                                hasException={currentUserId === pilot.id || currentUserId === task.author.id || (copilot ? copilot.id === currentUserId : false) || (axisSponsor ? axisSponsor.id === currentUserId : false)}
                                component={
                                    <DeleteButton
                                        setOpenDeleteModal={setIsOpenDeleteModal}/>
                                }
                            />
                        </ButtonsContainer>
                    </LastSection>
                    {displayModal()}
                </Container>
            )}
        </Draggable>

    )
}
const LastSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2rem;
  margin: 1rem 1rem 0.5rem 0.5rem;

`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 2rem;
`
const Date = styled.div`
  p {
    font-size: 0.7rem;
  }
`

const Content = styled.div`
  display: flex;
  padding: 0.5rem;

`
const PilotContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 0.5rem;
  background-color: ${props => props.isDragging || props.hasAction ? "var(--color-green-06)" : "#E4E58C"};
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  flex-grow: 1;

  p {
    font-weight: 700;
  }

  img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    object-fit: cover;
  }
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.5rem;
  border-radius: 5px;
  cursor: ${props => (props.isDragDisabled ? "initial" : "grab")};
  background-color: ${props => (props.isDragging || props.hasAction ? "var(--color-green-06)" : "#FEFF9C")};
`

export default Task